// extracted by mini-css-extract-plugin
export default {"profile":"profile-root_profile__Ts76y","nav":"profile-root_nav__FqLlW"};